const createQuery = (model) => {
  if (model === null || model === undefined) return null;

  const obj = Object.keys(model).map((key) => {
    if (!model[key]) return null;

    return `${key}=${model[key]}`;
  }).filter(item => item !== null).join('&');

  return `?${obj}`;
};

class Uri {
  /**
   *Creates an instance of Uri.
   * @param {domain: string, path: string, query: object} params
   * @memberof Uri
   */
  constructor(params) {
    this.url = params.domain;
    this.path = params.path;
    this.query = createQuery(params.query);
  }

  toString() {
    return `${this.url}${this.path}${!this.query ? '' : this.query}`;
  }
}


export default Uri;
